const theme = {
  colors: {
    bg: '#171c28',
    fg: '#1d2433',
    hover: '#2f3b54',
    active: '#2f3b54',
    grey: '#96a6cc',
    lightGrey: '#a2aabc',
    white: '#d7dce2',
    accent: '#ffcc66',
    blue: '#5ccfe6',
    green: '#bae67e',
    orange: '#ffae57',
    yellow: '#ffd580',
    purple: '#c3a6ff',
    red: '#ef6b73',
    seafoam: '#95e6cb',
    magenta: '#c678dd',
  },

  fonts: {
    base:
      'Fira Code, Fira Mono, SF Mono, Roboto Mono, Consolas, Monaco, Lucida Console, Courier New, monospace',
  },

  fontSizes: {
    xxs: '8px',
    xs: '10px',
    sm: '12px',
    base: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '24px',
  },

  spacing: {
    xxs: '0.25em',
    xs: '0.5em',
    sm: '0.75em',
    base: '1em',
    md: '1.25em',
    lg: '1.5em',
    xl: '1.75em',
    xxl: '2em',
  },

  easing: 'ease-in-out',
  transition: 'all 0.25s ease-in-out',
};

export default theme;
